import { render, staticRenderFns } from "./DocumentDialogSWT.vue?vue&type=template&id=76e414b4&scoped=true&"
import script from "./DocumentDialogSWT.vue?vue&type=script&lang=js&"
export * from "./DocumentDialogSWT.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDialogSWT.vue?vue&type=style&index=0&id=76e414b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e414b4",
  null
  
)

export default component.exports